"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationSelector = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../base-component");
const INPUT_SELECTOR = `[data-localization-input]`;
const FORM_SELECTOR = 'form';
class LocalizationSelector extends base_component_1.BaseComponent {
    mountComponent() {
        this.addListener(this, 'click', this.handleClick);
    }
    handleClick = (event) => {
        event.preventDefault();
        const target = event.target;
        const item = target.closest(`[data-localization-item]`);
        if (item) {
            const input = (0, utils_1.$el)(INPUT_SELECTOR, this);
            const form = (0, utils_1.$el)(FORM_SELECTOR, this);
            if (!input || !form || !item.dataset.value) {
                return;
            }
            input.value = item.dataset.value;
            form.submit();
        }
    };
}
exports.LocalizationSelector = LocalizationSelector;
